import React, { useState } from 'react';
import { Menu, MenuItem, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

import { UserAvatar } from '../UserAvatar';

export const AuthMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const { guest, signOut, setLoginDialogOpen, setSignupDialogOpen } = useAuth();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  if (!guest) {
    return (
      <>
        <Button
          onClick={() => setLoginDialogOpen(true)}
          data-cy="log-in-button"
          sx={{ color: 'text.primary' }}
        >
          Log In
        </Button>
        <Button
          onClick={() => setSignupDialogOpen(true)}
          variant="outlined"
          data-cy="sign-up-button"
          sx={{ color: 'text.primary' }}
        >
          Sign Up
        </Button>

      </>
    );
  }

  const menuTitle = 'Profile';

  return (
    <>
      <Button
        id="auth-menu-button"
        data-cy="auth-menu-button"
        aria-controls={menuOpen ? 'auth-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleClick}
        title={menuTitle}
      >
        <UserAvatar
          fullName={guest?.fullName}
          gravatarUrl={guest?.gravatarUrl}
        />
      </Button>
      <Menu
        id="auth-menu"
        MenuListProps={{
          'aria-labelledby': 'auth-menu-button',
        }}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={closeMenu}
      >
        <MenuItem component={RouterLink} to={'/guests/profile'}>
          Profile
        </MenuItem>
        <MenuItem
          component={Button}
          data-cy="sign-out-button"
          type="button"
          fullWidth
          onClick={() => {
            signOut();
            closeMenu();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};
